import EventEmitter from 'eventemitter3'

const drawActivityEvent = new EventEmitter<
  'playStart' | 'blindBoxOpened' | 'backToMainScene' | 'openTips'
>()

export default drawActivityEvent
